import { render } from "./FindWorksForm.vue?vue&type=template&id=5f0121ac&scoped=true"
import script from "./FindWorksForm.vue?vue&type=script&lang=js"
export * from "./FindWorksForm.vue?vue&type=script&lang=js"

import "./FindWorksForm.vue?vue&type=style&index=0&id=5f0121ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0121ac"]])

export default __exports__